import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Users, UserCheck, Kanban, CalendarCheck, X } from 'lucide-react';

const FloatingActionButton = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { label: 'Add Lead', icon: Users, path: '/leads', color: 'bg-blue-500' },
    { label: 'Add Client', icon: UserCheck, path: '/clients', color: 'bg-emerald-500' },
    { label: 'Add Deal', icon: Kanban, path: '/pipeline', color: 'bg-amber-500' },
    { label: 'Add Task', icon: CalendarCheck, path: '/tasks', color: 'bg-violet-500' },
  ];

  return (
    <div className="lg:hidden fixed bottom-6 right-4 z-50" data-testid="fab">
      {open && (
        <div className="mb-3 space-y-2">
          {actions.map((a) => {
            const Icon = a.icon;
            return (
              <button key={a.label} onClick={() => { setOpen(false); navigate(a.path); }}
                className={`flex items-center gap-2 px-4 py-2.5 ${a.color} text-white rounded-full shadow-lg text-sm font-medium whitespace-nowrap ml-auto`}
                data-testid={`fab-${a.label.toLowerCase().replace(' ', '-')}`}>
                <Icon className="w-4 h-4" /> {a.label}
              </button>
            );
          })}
        </div>
      )}
      <button onClick={() => setOpen(!open)}
        className={`ml-auto flex items-center justify-center w-14 h-14 rounded-full shadow-xl transition-all ${open ? 'bg-slate-700 rotate-45' : 'bg-slate-900'}`}
        data-testid="fab-toggle">
        {open ? <X className="w-6 h-6 text-white" /> : <Plus className="w-6 h-6 text-white" />}
      </button>
    </div>
  );
};

export default FloatingActionButton;
